export default function AdInline() {
  return (
    <div className="glass p-4 rounded-xl my-6 text-center shadow-md">
      <p className="text-sm text-gray-300">Sponsored</p>

      <div className="mt-3 bg-gray-500/20 dark:bg-white/10 h-40 rounded-lg flex items-center justify-center">
        <span className="opacity-50 text-xs">In-Feed Ad</span>
      </div>
    </div>
  );
}
